$(document).ready(function () {
    initActions();
    initMainMenu();
    initProductCarousels();
    initLayout();
    initSelects();
    initFilters();
    initTabs();
    initNumbers();
    initFlippers();
    initBigCart();
    initRelatedFields();
    initOrderForm();
    initTextTables();
    resize();
    initGalleries();


    $('.has-tooltip').tooltip();
});

sliders = [];

window.addEventListener('load', function () {
    initScrollableText();
});

function resize() {
    if ($(window).width() < 768) {
        $('.heading h1').after($('#mobile-filter-wrap'));
    } else {
        $('#mobile-filter-wrap').prependTo('aside');
    }
}

var timo;
window.onresize = function () {
    clearTimeout(timo);
    timo = setTimeout(resize, 100);
};

$('.navbar-toggler').click(function () {
    $(this).toggleClass('active');
    $('html').toggleClass('no-scroll', $(this).hasClass('active'));
});

function initActions() {
    $(document).on('keyup', '.action-wrap', function (e) {
        if (e.keyCode === 27) {
            $('.visible').removeClass('visible');
        }
    });

    $('.action-menu').css({
        'max-height': $(window).height() - $('#header').height()
    });

    $(document).on('click touch', function (e) {
        if (!clickInside(e, '.action-wrap')) {
            $('.visible')
                .not($('#to-top'))
                .removeClass('visible clicked');
            return;
        }
    });

    $(document).on('mouseenter', '.action-wrap', function () {
        $(this).addClass('visible');
    });

    $(document).on('mouseleave', '.action-wrap:not(.clicked)', function (e) {
        if ($(e.relatedTarget).length > 0) {
            $(this).removeClass('visible');
        }
    });

    $(document).on('click touch', '.action-toggle', function () {
        var actionWrap = $(this).closest('.action-wrap');
        var menu = $('.action-menu', actionWrap);

        $('.action-wrap.visible.clicked')
            .filter(function (index, element) {
                return !$(element).is(actionWrap);
            }).removeClass('visible clicked');

        //ja nav menu, toggleris aizved uz norādīto linku
        if (menu.length < 1) {
            return true;
        }

        menu.width(menu.width());
        menu.css({
            'max-height': $(window).height() - $('#header').height()
        });

        if (!actionWrap.hasClass('clicked') && actionWrap.hasClass('visible')) {
            actionWrap.addClass('clicked');
            return;
        }



        if (actionWrap.hasClass('visible') && actionWrap.hasClass('clicked')) {
            actionWrap.removeClass('visible clicked');
            actionWrap
                .trigger('mouseleave')
                .trigger('touchend')
                .trigger('touchcancel');
            return;
        }


        setPosition(menu);

        if (
            $(this)
                .prop('nodeName')
                .toLowerCase() == 'a'
        ) {
            return false;
        }
    });

    function setPosition(menu) {
        var scrollBarWidth =
            $('html').prop('offsetWidth') - $('html').prop('clientWidth');
        var rightMax = $(window).width() - scrollBarWidth;
        var menuLeft = menu.offset().left;
        var menuRight = menuLeft + menu.outerWidth(true);

        if (menuRight > rightMax) {
            menu.offset({
                left: menuLeft - Math.abs(rightMax - menuRight) * 2
            });
            return false;
        }

        if (menuLeft <= scrollBarWidth) {
            menu.offset({
                left: menuLeft + Math.abs(scrollBarWidth - menuLeft)
            });
            return false;
        }

        menu.attr('style', '');
        rightMax = $(window).outerWidth() - scrollBarWidth;
        menuLeft = menu.offset().left + menu.position().left / 2;
        menuRight = menuLeft + menu.outerWidth();
        if (menuRight > rightMax) {
            menu.offset({
                left: menuLeft - Math.abs(rightMax - menuRight) * 2
            });
        }
    }
}

function initMainMenu() {
    initSearch();
    initSmallCart();
    initCategoryMenu();
    initMobileMenu();

    function initSearch() {
        $(document).on('focus', '#search-needle', function () {
            var searchInput = $(this);
            var wrap = searchInput.closest('.action-wrap');
            wrap.addClass('focused');
        });

        $(document).on('click', function (e) {
            var searchInput = $('#search-needle');
            var wrap = searchInput.closest('.action-wrap');

            if (!clickInside(e, '.search-wrap')) {
                wrap.removeClass('focused');
            }
        });
    }

    function initSmallCart() {
        addScrollbar($('.small-cart'), true, true);
    }

    function initCategoryMenu() {
        $(document).on('mouseenter', '.nav-item', function () {
            var categoryWrap = $(this).children('.submenu.category-wrap');
            var topOffset = $(this).offset().top - $(window).scrollTop() + $(this).height() - 1;

            categoryWrap.css({
                top: topOffset
            });

            $('.categories', categoryWrap).css({
                maxHeight: $(window).height() - topOffset
            });
        });
    }

    function initMobileMenu() {
        var wrap = $('#header');
        $('.navbar', wrap).append(
            '<div id="mobile-menu" class="collapse collapse-nav"></div>'
        );
        var mobileMenu = $('#mobile-menu');
        var navItems = $(
            '.bottom .collapse-nav .navbar-nav>.nav-item',
            wrap
        ).clone();
        var mobileLangmenu = $('.language-wrap', wrap).clone();
        mobileLangmenu
            .find('#language-menu')
            .attr('id', 'language-menu-mobile');

        mobileMenu.append($('.search-wrap', wrap).clone());
        navItems.children('.submenu-toggle, .submenu').remove();
        mobileMenu.append(navItems);
        mobileMenu.append(mobileLangmenu);
    }

    $('#header').addClass('initialized');
}

function clickInside(e, selector) {
    var target = e.relatedTarget ? $(e.relatedTarget) : $(e.target);
    if (typeof target != 'undefined' && target != 'null') {
        if (target.parents(selector).length > 0 || target.is(selector)) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

function addScrollbar(element, outside, preventScrollParent) {
    preventScrollParent = preventScrollParent ? true : false;

    element.mCustomScrollbar('destroy');
    setTimeout(function () {
        element.mCustomScrollbar({
            scrollbarPosition: outside ? 'outside' : 'inside',
            scrollInertia: 150,
            mouseWheel: {
                preventDefault: preventScrollParent
            },
            callbacks: {
                onTotalScroll: function () {

                    if (!preventScrollParent) {
                        element.mCustomScrollbar("scrollTo", this.mcs.top * -1 - 1, {
                            timeout: 0,
                            scrollEasing: false
                        });
                        $('html, body').animate({
                            scrollTop: '+=200'
                        }, 200);
                    }
                },
                onTotalScrollBack: function () {
                    if (!preventScrollParent) {
                        element.mCustomScrollbar("scrollTo", 1, {
                            timeout: 0,
                            scrollEasing: false
                        });
                        $('html, body').animate({
                            scrollTop: '-=200'
                        }, 200);
                    }
                }
            }
        });
    });
}

function initProductCarousels() {
    var carousels = $(
        '.product-row.scrollable:visible:not(.owl-carousel)'
    ).filter(function () {
        return $(this).css('visibility') != 'hidden';
    });
    if (carousels.length < 1) {
        return;
    }
    carousels.each(function () {
        var wrap = $(this).closest('.product-block');

        var heights = $('.product', wrap)
            .map(function () {
                return $(this).height();
            })
            .get(),
            maxHeight = Math.max.apply(null, heights);

        // $('.product', wrap).height(maxHeight);

        var owl = $(this)
            .addClass('owl-carousel')
            .owlCarousel({
                items: 5,
                dots: true,
                slideBy: 'page',
                mouseDrag: false,
                responsive: {
                    0: {
                        items: 1,
                        autoWidth: true
                    },
                    390: {
                        items: 2
                    },
                    530: {
                        items: 3,
                        autoWidth: false
                    },
                    767: {
                        items: 4
                    },
                    991: {
                        items: 5
                    }
                },
                responsiveBaseElement: $(this),
                onInitialized: function (e) {
                    if ($('.owl-dot', $(this)[0].$element).length <= 1) {
                        wrap.find('.c-control').hide();
                    } else {
                        wrap.find('.c-control')
                            .show()
                            .css('display', 'flex');
                    }
                },
                onResized: function (e) {
                    if (e.page.count <= 1) {
                        wrap.find('.c-control').hide();
                    } else {
                        wrap.find('.c-control')
                            .show()
                            .css('display', 'flex');
                    }
                }
            });
    });
}

$(document).on('click', '.c-control', function () {
    var owl = $(this).siblings('.owl-carousel');
    if ($(this).hasClass('carousel-prev')) {
        owl.trigger('prev.owl.carousel');
    } else {
        owl.trigger('next.owl.carousel');
    }
    return false;
});

function initLayout() {
    var heights = 0;
    var footerMT = $('footer').css('margin-top');

    $('body>*:not(script)').each(function () {
        heights += $(this).outerHeight();
    });

    if ($(window).height() - heights > parseInt(footerMT)) {
        $('footer').css({
            'margin-top': $(window).height() - heights - parseInt(footerMT)
        });
    }
}

function initSelects() {
    var selects = $('select.styled:not(.done)');
    styleSelects();

    $(document).on('click', 'select.styled', function () {
        $(this)
            .parent()
            .focus()
            .toggleClass('clicked');
    });

    $(document).on('click', '.select-value', function () {
        $(this)
            .parent()
            .focus()
            .toggleClass('clicked');
    });

    $(document).on('click', '.select-options .option', function () {
        var wrap = $(this).parents('.select-wrap');
        var selectValue = wrap.find('.select-value');
        wrap.removeClass('clicked');
        selectValue.text($(this).text());
        wrap.find('select')
            .val($(this).attr('data-value'))
            .change();
        $('.option', wrap).removeClass('selected');
        $(this).addClass('selected');
        if ($(this).attr('data-default')) {
            selectValue.removeClass('selected');
        } else {
            selectValue.addClass('selected');
        }
    });

    //find option by pressed keys
    var typingTimer;
    var doneTypingInterval = 700;
    var needle = '';

    $(document).on('keypress', '.select-wrap', function (e) {
        needle += e.key;
        clearTimeout(typingTimer);
        selectWrap = $(this);

        typingTimer = setTimeout(function () {
            doneTyping(selectWrap);
        }, doneTypingInterval);
    });

    function doneTyping(selectWrap) {
        var opt = $('.option', selectWrap).filter(function () {
            var text = $(this)
                .text()
                .toLowerCase()
                .replace(/\s/g, '');
            needle = needle.replace(/\s/g, '');
            return text.indexOf(needle) === 0;
        });
        if (opt.length > 0) {
            selectWrap
                .find('select-options')
                .mCustomScrollbar('scrollTo', opt.eq(0).position().top);
            opt.eq(0).click();
        }
        needle = '';
    }
}

function styleSelects() {
    var selects = $('select.styled:not(.done)');
    selects.each(function () {
        $(this).wrap('<div class="select-wrap"></div>');
        var wrap = $(this).parent();
        var selected = $(this).find(':selected');
        var def = $(this).find('[data-default="true"]');
        var notdefault = '';
        selected.attr('selected', true);

        if (selected.val() != def.val()) {
            notdefault = true;
        }
        wrap.append(
            '<div class="select-value ' +
            (notdefault ? 'selected' : '') +
            '">' +
            selected.text() +
            '</div>'
        );
        var html = '<div class="select-options">';
        $(this)
            .find('option')
            .each(function () {
                html +=
                    '<div class="option ' +
                    ($(this).attr('selected') ? 'selected' : '') +
                    '" data-value="' +
                    $(this).val() +
                    '" ' +
                    ($(this).data('default') ? 'data-default="true"' : '') +
                    '>' +
                    $(this).text() +
                    '</div>';
            });
        html += '</div>';

        wrap.append(html);
        wrap.addClass($(this).attr('class'));
        $(this).addClass('done');

        if (
            $('.select-options', wrap).outerHeight() >=
            parseInt($('.select-options', wrap).css('max-height'))
        ) {
            $('.select-options', wrap).mCustomScrollbar();
        }
    });

    $('.select-wrap')
        .attr('tabindex', '1')
        .focusout(function () {
            $(this).removeClass('clicked');
        });
}

function initFilters() {
    var filterTimo;
    var form = $('#filter-form');
    var submitTimeout = 1000;
    var filters = $('.filter', form);

    $(document).on('click', '#filter-toggler', function () {
        $('#filter-form').slideToggle(300);
    });

    $('.clear').click(function () {
        resetForm();
    });

    if (typeof FORM_SUBMIT_TIMEOUT != 'undefined') {
        submitTimeout = FORM_SUBMIT_TIMEOUT;
    }

    // initPriceFilter();
    // initStockFilter();
    initFilterSliders();
    addScrolls();

    if ($('#form').length < 1) {
        return;
    }

    function addScrolls() {
        if (filters.length < 1) {
            return false;
        }

        addScrollbar($('.content', filters));
    }

    function initPriceFilter() {
        if ($('.price-inputs').length < 1) {
            return false;
        }

        var minPrice = $('.price-inputs [name="price-from"]');
        var maxPrice = $('.price-inputs [name="price-to"]');
        var min = parseInt(minPrice.attr('min'));
        var max = parseInt(maxPrice.attr('max'));
        var priceTimo;
        var slider = $('.price-slider', form).slider({
            animate: 'fast',
            min: min,
            max: max,
            range: true,
            values: [minPrice.val(), maxPrice.val()],
            slide: function (event, ui) {
                if (ui.values[0] >= ui.values[1]) {
                    return false;
                }
                minPrice.val(ui.values[0]);
                maxPrice.val(ui.values[1]);
                submitForm();
            }
        });

        $('.price-inputs input').on('keyup change', function (e) {
            clearTimeout(priceTimo);
            priceTimo = setTimeout(function () {
                var mip = parseInt(minPrice.val());
                var map = parseInt(maxPrice.val());

                if (isNaN(mip)) {
                    mip = 0;
                }

                if (isNaN(map)) {
                    map = mip;
                }

                if (mip <= min) {
                    minPrice.val(min);
                }
                if (map > max) {
                    maxPrice.val(max);
                }
                if ($(this).attr('id') == 'price-from') {
                    if (mip >= map) {
                        minPrice.val(map - 1);
                    }
                } else {
                    if (mip >= map) {
                        maxPrice.val(mip + 1);
                    }
                }

                if (e.originalEvent) {
                    maxPrice.trigger('change');
                    minPrice.trigger('change');
                }
                slider.slider('values', [minPrice.val(), maxPrice.val()]);
                submitForm();
            }, 700);
        });
    }

    function initStockFilter() {
        if ($('.price-inputs').length < 1) {
            return false;
        }

        var minPrice = $('.price-inputs [name="stock-from"]');
        var maxPrice = $('.price-inputs [name="stock-to"]');
        var min = parseInt(minPrice.attr('min'));
        var max = parseInt(maxPrice.attr('max'));
        var priceTimo;
        var slider = $('.stock-slider', form).slider({
            animate: 'fast',
            min: min,
            max: max,
            range: true,
            values: [minPrice.val(), maxPrice.val()],
            slide: function (event, ui) {
                if (ui.values[0] >= ui.values[1]) {
                    return false;
                }
                minPrice.val(ui.values[0]);
                maxPrice.val(ui.values[1]);
                submitForm();
            }
        });

        $('.price-inputs input').on('keyup change', function (e) {
            clearTimeout(priceTimo);
            priceTimo = setTimeout(function () {
                var mip = parseInt(minPrice.val());
                var map = parseInt(maxPrice.val());

                if (isNaN(mip)) {
                    mip = 0;
                }

                if (isNaN(map)) {
                    map = mip;
                }

                if (mip <= min) {
                    minPrice.val(min);
                }
                if (map > max) {
                    maxPrice.val(max);
                }
                if ($(this).attr('id') == 'stock-from') {
                    if (mip >= map) {
                        minPrice.val(map - 1);
                    }
                } else {
                    if (mip >= map) {
                        maxPrice.val(mip + 1);
                    }
                }

                if (e.originalEvent) {
                    maxPrice.trigger('change');
                    minPrice.trigger('change');
                }
                slider.slider('values', [minPrice.val(), maxPrice.val()]);
                submitForm();
            }, 700);
        });
    }

    function initFilterSliders() {
        if ($('.price-inputs').length < 1) {
            return false;
        }

        $('.filter', form).each(function () {
            var filter = $(this);

            var minPrice = $('.price-inputs input', filter).eq(0);
            var maxPrice = $('.price-inputs input', filter).eq(1);
            var min = parseInt(minPrice.attr('min'));
            var max = parseInt(maxPrice.attr('max'));
            var priceTimo;
            var slider = $('.slider', filter).slider({
                animate: 'fast',
                min: min,
                max: max,
                range: true,
                values: [minPrice.val(), maxPrice.val()],
                slide: function (event, ui) {
                    if (ui.values[0] >= ui.values[1]) {
                        return false;
                    }
                    minPrice.val(ui.values[0]);
                    maxPrice.val(ui.values[1]);
                    submitForm();
                }
            });

            $('.price-inputs', filter).on('keyup change', function (e) {
                clearTimeout(priceTimo);
                priceTimo = setTimeout(function () {
                    var mip = parseInt(minPrice.val());
                    var map = parseInt(maxPrice.val());

                    if (isNaN(mip)) {
                        mip = 0;
                    }

                    if (isNaN(map)) {
                        map = mip;
                    }

                    if (mip <= min) {
                        minPrice.val(min);
                    }
                    if (map > max) {
                        maxPrice.val(max);
                    }
                    if ($(this).hasClass('from')) {
                        if (mip >= map) {
                            minPrice.val(map - 1);
                        }
                    } else {
                        if (mip >= map) {
                            maxPrice.val(mip + 1);
                        }
                    }

                    if (e.originalEvent) {
                        maxPrice.trigger('change');
                        minPrice.trigger('change');
                    }
                    slider.slider('values', [minPrice.val(), maxPrice.val()]);
                    submitForm();
                }, 700);
            });
        });
    }

    function submitForm() {
        clearTimeout(filterTimo);
        filterTimo = setTimeout(function () {
            form.submit();
        }, submitTimeout);
    }

    function resetForm() {
        form.find('input')
            .val('')
            .prop('checked', false)
            .change();
        form.submit();
    }
}

function initNumbers() {
    var numberTimo;
    var numberInt;

    $(document).on('click touchend', '.number-wrap .number-control', function () {
        var input = $(this).siblings('input');
        var min = parseInt(input.attr('min'));
        var max = parseInt(input.attr('max'));

        if ($(this).hasClass('minus')) {
            decrease(input, min);
        } else {
            increase(input, max);
        }
        return false;
    });

    $(document).on(
        'mousedown touchstart',
        '.number-wrap .number-control',
        function () {
            var input = $(this).siblings('input');
            var min = parseInt(input.attr('min'));
            var max = parseInt(input.attr('max'));
            var speed = 500;

            if ($(this).hasClass('minus')) {
                numberTimo = setTimeout(function () {
                    numberInt = setInterval(function () {
                        decrease(input, min);
                    }, 50);
                }, 500);
            } else {
                numberTimo = setTimeout(function () {
                    numberInt = setInterval(function () {
                        increase(input, max);
                    }, 50);
                }, 500);
            }
            return false;
        }
    );

    $(document).on(
        'mouseup touchend',
        '.number-wrap .number-control',
        function () {
            clearInterval(numberInt);
            clearInterval(numberTimo);
        }
    );

    $(document).on(
        'change keyup',
        '.number-wrap input[type="number"]',
        function () {
            var input = $(this);
            var min = parseInt(input.attr('min'));
            var max = parseInt(input.attr('max'));

            if (input.val() > max) {
                input.val(max);
            }
            if (input.val() < min) {
                input.val(min);
            }
        }
    );

    function increase(input, max) {
        if (max) {
            if (input.val() >= max) {
                return false;
            }
        }
        input.val(parseInt(input.val()) + 1);
    }

    function decrease(input, min) {
        if (input.val() > min) {
            input.val(input.val() - 1);
        }
    }
}

function initTabs() {
    $(document).on('click', '.tab-wrap .tab a, .tab-wrap .tab span', function (
        e
    ) {
        var tab = $(this).closest('.tab');
        var wrap = tab.parents('.tab-wrap');
        var currentTabContent = $('.tabbed-content.active', wrap);
        var nextTabContent = $('.tabbed-content', wrap).filter(function (
            index,
            element
        ) {
            return $(element).data('tab') == tab.data('tab');
        });
        if (currentTabContent.index() == nextTabContent.index()) {
            return;
        }

        if (
            $(this)
                .prop('nodeName')
                .toLowerCase() == 'a'
        ) {
            var url = $(this).attr('href');
        } else {
            var url = $(this).data('url');
        }

        currentTabContent.addClass('loading');

        $.ajax({
            type: 'POST',
            url: url,
            success: function (response) {
                nextTabContent.html(response);
                tab.addClass('active')
                    .siblings('.tab')
                    .removeClass('active');
                nextTabContent
                    .addClass('active')
                    .siblings()
                    .removeClass('loading active');
                initProductCarousels();

                $('.has-tooltip', nextTabContent).tooltip();
            }
        });
        return false;
    });
}

function changePopupImage() {
    var index = $('#product-gallery .thumb').index($('.thumb.active'));
    $('#product-gallery-popup .thumb').eq(index).click();
}

function initGalleries(selected) {
    if ($('.gallery').length < 1) {
        return false;
    }

    $('.gallery:not(.inited)').each(function () {
        var wrap = $(this);
        var slider = $('.gallery-element', wrap).lightSlider({
            gallery: true,
            item: 1,
            thumbItem: 5,
            loop: true,
            pager: true,
            thumbMargin: 10,
            controls: false,
            enableDrag: true,
            onAfterSlide: function(el) {
                var currentSlide = $('.item.active', el);
                var combinationId = currentSlide.data('id');

                if (typeof Product != 'undefined') {
                    Product.galleryChangeCombinationUpdate(combinationId);
                }
            }
        });

        var id =  wrap.attr('id');
        sliders[id] = slider;

        $('.control.next', wrap).on('click', function() {
            slider.goToNextSlide();
            return false;
        });

        $('.control.prev', wrap).on('click', function() {
            slider.goToPrevSlide();
            return false;
        });

        $('.gallery-element .item', wrap).on('click', function() {
            var index = $('.gallery-element .item', wrap).index($(this));
            var pswpElement = document.querySelectorAll('.pswp')[0];
            var items = [];

            $('.gallery-element .item:not(.clone)', wrap).each(function () {
                if ($(this).hasClass('video')) {
                    items.push({
                        html: '<iframe height="480" width="720" src="' + $(this).data('full') + '">'
                    });
                } else {
                    items.push({
                        src: $(this).data('full'),
                        w:  $(this).data('width'),
                        h:  $(this).data('height')
                    });
                }
            });

            var options = {
                index: index - 1// start at first slide
            };
            var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
            gallery.listen('afterChange', function() {
                var curIndex = gallery.getCurrentIndex() + 1;
                slider.goToSlide(curIndex);
            });
            gallery.init();
        });

        wrap.addClass('inited');
    });
}

function initFlippers() {
    $('.flipper').each(function () {
        var front = $('.front', $(this));
        var back = $('.back', $(this));

        if (front.height() % 2 != 0) {
            front.css({ 'min-height': $(this).height() + 1 });
        }
        if (back.height() % 2 != 0) {
            back.css({ 'min-height': $(this).height() + 1 });
        }
        if ($(this).closest('.flip-container').hasClass('hovered')) {
            window.addEventListener('load', function () {
                if (typeof grecaptcha != 'undefined') {
                    grecaptcha.execute();
                }
            })
        }
    });
    $(document).on('click', '.flipper-toggler', function (e) {
        $(this)
            .closest('.flip-container')
            .toggleClass('hovered');

        if (typeof grecaptcha != 'undefined') {
            grecaptcha.execute();
        }
        return false;
    });
}

function initScrollableText() {
    if ($('.scrollable-text').length < 1) {
        return false;
    }
    $('.scrollable-text').each(function () {
        addScrollbar($(this), true, false);
    });
}

function initBigCart() {
    if ($('.side-cart .products').length < 1) {
        return;
    }

    addScrollbar($('.side-cart .products'), true, false);
}

function initRelatedFields() {
    $(document).on('change', '[type="checkbox"], [type="radio"]', function () {
        var wrap = $(this).closest('form');
        var fieldWrap = $('[data-selector="' + $(this).attr('id') + '"]');
        var sameName = $('[name="' + $(this).attr('name') + '"]', wrap).not(
            $(this)
        );

        if ($(this).attr('type') == 'checkbox') {
            sameName = $('[name="' + $(this).attr('name') + '"]', wrap);
        }

        var negate = fieldWrap.data('negate') ? true : false;

        sameName.each(function () {
            //iziet cauri visiem inputiem ar to pašu vārdu un paslēpj viņu saistītos laukus
            var sameNameFieldWrap = $(
                '[data-selector="' + $(this).attr('id') + '"]'
            );

            if (sameNameFieldWrap.length < 1) {
                return true; //darbojas kā continue;
            }

            sameNameFieldWrap.slideUp().addClass('disabled');
            //unrequiro, lai netraucē submitot
            var requiredInputs = $('input', sameNameFieldWrap).filter(function (
                index,
                element
            ) {
                return $(element).attr('required');
            });

            requiredInputs.attr('data-required', true).removeAttr('required');
        });

        if (fieldWrap.length < 1) {
            return;
        }

        var requiredInputs = $('input', fieldWrap).filter(function (
            index,
            element
        ) {
            return $(element).data('required');
        });

        var relatedParents = $(this).parents('.related-fields');
        var disabledParent = false;

        relatedParents.each(function () {

            if ($(this).hasClass('disabled')) {
                disabledParent = true;
            }
        });

        var checkval = (negate ? !$(this).prop('checked') : $(this).prop('checked')) && !disabledParent;
        if (checkval) {
            requiredInputs.attr('required', true);
            fieldWrap.slideDown().removeClass('disabled');
        } else {
            requiredInputs.attr('required', false);
            fieldWrap.slideUp().addClass('disabled');
        }

        $('[type="checkbox"], [type="radio"]', fieldWrap).change();
    });

    $('[type="radio"], [type="checkbox"]')
        .filter(function (index, element) {
            return (
                $(element).prop('checked') &&
                $('[data-selector="' + $(element).attr('id') + '"]').length > 0
            );
        })
        .trigger('change');
}

function initOrderForm() {
    $(document).on('click', '.edit-step', function () {
        editStep($(this).closest('.step'));
        return false;
    });

    $('.step input').on('invalid', function (e) {
        var firstInvalid = $(this)
            .closest('.step')
            .find('input:invalid')
            .eq(0);

        if ($(this).is(firstInvalid)) {
            $('html, body').animate(
                {
                    scrollTop:
                        firstInvalid.offset().top -
                        $('#header').outerHeight() -
                        30
                },
                200
            );
        }
    });
}

function nextStep(step) {
    var nextStep = step.next('.step');

    if (nextStep.length < 1) {
        return false;
    }
    step.addClass('done')
        .removeClass('active')
        .children('form')
        .slideUp();
    nextStep
        .addClass('active')
        .children('form')
        .slideDown();

    setTimeout(function () {
        $('body, html').animate(
            {
                scrollTop: nextStep.offset().top - $('#header').outerHeight()
            },
            200
        );
    }, 400);
}

function editStep(step) {
    step.nextAll('.step')
        .removeClass('active done')
        .children('form')
        .slideUp();
    step.addClass('active')
        .removeClass('done')
        .children('form')
        .slideDown();
}

function initTextTables() {
    $('.formatedtext table').each(function () {
        var table = $(this);

        if (table.parents('.table-wrap').length > 0) {
            return;
        }

        table.hide();

        setTimeout(function () {
            var maxWidth = table.parent().width();
            table.wrap('<div class="table-wrap"></div>');
            table.parent().css({ 'max-width': maxWidth });
            table.show();
        });
    });
}
